module.exports = __webpack_public_path__ + "static/media/fan_room(1).0bf2624a.jpg";